import { Routes } from '@angular/router';
import { Login } from './login/login';
import { LmsConnectionTest } from './lmsconnectiontest/lmsconnectiontest';
import { Dashboard } from './dashboard/dashboard';
import { AuthCallback } from './auth-callback/auth-callback';
import { MyDataComponent } from './my-data/my-data';
import { EinsatzplanungComponent } from './lecturer/einsatzplanung/einsatzplanung';
import { AbrechnungenComponent } from './lecturer/abrechnungen/abrechnungen';
import { LecturesComponent } from './lecturer/lectures/lectures';
import { AvailabilityComponent } from './lecturer/availability/availability';
import { TeachabilityComponent } from './lecturer/teachability/teachability';
import { PlanningComponent } from './lecturer/planning/planning';
import { PlanningPeriodOverviewComponent } from './lecturer/planning-overview/planning-overview';
import { DegreesComponent } from './student/degrees/degrees';
import { ModulesComponent } from './student/modules/modules';
import { StudentLecturesComponent } from './student/lectures/student-lectures';
import { RechnungenComponent } from './student/rechnungen/rechnungen';
import { UnterlagenComponent } from './student/unterlagen/unterlagen';
import { authGuard } from './services/auth.guard';
import { lecturerGuard } from './services/lecturer.guard';
import { studentGuard } from './services/student.guard';
import { LayoutComponent } from './shared/layout/layout';
import { ExtAuth } from './ext-auth/ext-auth';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: Login },
  { path: 'auth/callback', component: AuthCallback },
  { path: 'lmsconnectiontest', component: LmsConnectionTest },
  { path: 'ext-auth', component: ExtAuth },

  // Protected routes with persistent layout
  {
    path: 'app',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: '/app/dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: Dashboard },
      { path: 'my-data', component: MyDataComponent },
      // Student-only routes (protected by studentGuard)
      {
        path: 'degrees',
        component: DegreesComponent,
        canActivate: [studentGuard],
      },
      {
        path: 'modules',
        component: ModulesComponent,
        canActivate: [studentGuard],
      },
      {
        path: 'lectures',
        component: StudentLecturesComponent,
        canActivate: [studentGuard],
      },
      {
        path: 'degrees-modules',
        redirectTo: 'degrees',
        pathMatch: 'full',
      },
      {
        path: 'rechnungen',
        component: RechnungenComponent,
        canActivate: [studentGuard],
      },
      {
        path: 'unterlagen',
        component: UnterlagenComponent,
        canActivate: [studentGuard],
      },
      // Lecturer-only routes (protected by lecturerGuard)
      {
        path: 'einsatzplanung',
        redirectTo: 'availability',
        pathMatch: 'full' as const,
      },
      // COMMENTED OUT: Vorerst nicht erreichbar
      /*
      {
        path: 'abrechnungen',
        component: AbrechnungenComponent,
        canActivate: [lecturerGuard],
      },
      */
      // COMMENTED OUT: Vorerst nicht erreichbar
      /*
      {
        path: 'lectures',
        component: LecturesComponent,
        canActivate: [lecturerGuard],
      },
      */
      {
        path: 'availability',
        component: AvailabilityComponent,
        canActivate: [lecturerGuard],
      },
      {
        path: 'teachability',
        component: TeachabilityComponent,
        canActivate: [lecturerGuard],
      },
      {
        path: 'planning-overview',
        component: PlanningPeriodOverviewComponent,
        canActivate: [lecturerGuard],
      },
      {
        path: 'confirmed-plan',
        component: PlanningPeriodOverviewComponent,
        canActivate: [lecturerGuard],
        data: { onlyConfirmed: true },
      },
      // COMMENTED OUT: Vorerst nicht erreichbar
      /*
      {
        path: 'planning',
        component: PlanningComponent,
        canActivate: [lecturerGuard],
      },
      */
      {
        path: 'settings',
        loadComponent: () => import('./shared/settings/settings').then((m) => m.SettingsComponent),
      },
    ],
  },
];
